import { useEffect, useState } from "react";
import { Button, Flex, Text } from "@chakra-ui/react";
import Image from "next/image";
import { TRatingItems } from "@/Types/types";

interface Props {
  ratingData: any;
  hasReview: Boolean;
}

export default function Rating({ ratingData, hasReview }: Props) {
  const [ratingItems, setRatingItems] = useState<TRatingItems[]>([]);
  const NUMBER_PAWS = 5

  const handleToYourOpinion = (e: any) => {
    e.preventDefault();
    document
      .getElementById("your-opinion")!
      .scrollIntoView({ behavior: "smooth" });
  }

  const handleToOpinions = (e: any) => {
    e.preventDefault();
    document
      .getElementById("opinions")!
      .scrollIntoView({ behavior: "smooth" });
  }

  useEffect(() => {
    setRatingItems([
      {
        icon: "/images/rating/icon1.svg",
        name: "Vive em apartamento",
        value: ratingData.liveInApartment
      },
      {
        icon: "/images/rating/icon2.svg",
        name: "Apego com o dono",
        value: ratingData.attachedToTheOwner
      },
      {
        icon: "/images/rating/icon3.svg",
        name: "Tendência de latir",
        value: ratingData.barkTendency
      },
      {
        icon: "/images/rating/icon4.svg",
        name: "Facilidade para adestrar",
        value: ratingData.easeToTrain
      },
      {
        icon: "/images/rating/icon5.svg",
        name: "Convívio com crianças",
        value: ratingData.socializingWithChildren
      },
      {
        icon: "/images/rating/icon6.svg",
        name: "Convívio com outros animais",
        value: ratingData.coexistenceWithOtherAnimals
      },
      {
        icon: "/images/rating/icon7.svg",
        name: "Queda de pelos",
        value: ratingData.hairLoss
      },
    ])
  }, [ratingData])


  return (
    <Flex
      direction="column"
      width={{ base: "100%", lg: "387px" }}
      p={{ base: "16px", lg: "32px" }}
      justifyContent="space-between"
      borderRadius="16px"
      bgColor="#FFF"
      boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.06), 0px 1px 3px 0px rgba(0, 0, 0, 0.10)"
    >
      <Flex direction="column" gap="32px">
        {ratingItems.map((item, index) => (
          <Flex key={index} gap="16px" direction="column">
            <Flex gap="8px">
              <Image
                src={item.icon}
                alt="icon"
                width="26"
                height="26"
              />
              <Text
                fontSize="18px"
                lineHeight="28px"
                color="gray.500"
              >
                {item.name}
              </Text>
            </Flex>
            <Flex gap="16px">
              {ratingItems.slice(0, NUMBER_PAWS).map((_, i) => (
                <Image
                  key={i}
                  src="/images/rating/paw.svg"
                  alt="paw"
                  width={24}
                  height={20}
                  style={{ filter: item.value !== undefined && item.value >= (i + 1) ? 'none' : 'brightness(1.4) grayscale(1)' }}
                />
              ))}
            </Flex>
          </Flex>
        ))}
      </Flex>
      <Flex direction="column" mt={{ base: "48px", lg: "0" }}>
        <Button
          aria-label="evaluate"
          size="md"
          borderRadius="54px"
          bgColor="purple.600"
          _hover={{ bgColor: "purple.500" }}
          color="#FFF"
          onClick={handleToYourOpinion}
        >
          Avaliar também
        </Button>
        <Button
          aria-label="see-evaluate"
          size="md"
          borderRadius="54px"
          bgColor="transparent"
          _hover={{ color: "gray.400" }}
          color="gray.500"
          onClick={hasReview ? handleToOpinions : handleToYourOpinion}
        >
          Ver avaliações dos usuários
        </Button>
      </Flex>
    </Flex>
  )
}
